import { Language } from '../translations'

export const skillTranslations: Record<string, Record<Language, string>> = {
  edit: { en: "Edit", fi: "Muokkaa" },
  delete: { en: "Delete", fi: "Poista" },
  cancel: { en: "Cancel", fi: "Peruuta" },
  save: { en: "Save", fi: "Tallenna" },
  add: { en: "Add", fi: "Lisää" },
  saving: { en: "Saving...", fi: "Tallennetaan..." },
  adding: { en: "Adding...", fi: "Lisätään..." },
  description: { en: "Description", fi: "Kuvaus" },
  skillName: { en: "Skill", fi: "Osaaminen" },
  skillLevel: { en: "Skill Level", fi: "Osaamistaso" },
  skillNamePlaceholder: { en: "Enter skill, ie. React, Java, Project leading, Leading a scrum team", fi: "Syötä osaaminen, esim. React, Java, projektin johtaminen, Scrum tiimin vetäminen" },
  skillDescriptionPlaceholder: { en: "Enter description (optional)", fi: "Syötä kuvaus (valinnainen)" },
  selectSkillLevel: { en: "Select skill level", fi: "Valitse osaamistaso" },
  addSkill: { en: "Add Skill", fi: "Lisää osaaminen" },
  editSkill: { en: "Edit Skill", fi: "Muokkaa osaamista" },
  addNewSkill: { en: "Add New Skill", fi: "Lisää uusi osaaminen" },
  noSkillsFound: { en: "No skills found.", fi: "Osaamisia ei löytynyt." },
  noSkills: { en: "No skills", fi: "Ei osaamisia" },
  skillAddedSuccess: { en: "Skill added successfully", fi: "Osaaminen lisätty onnistuneesti" },
  skillUpdatedSuccess: { en: "Skill updated successfully", fi: "Osaaminen päivitetty onnistuneesti" },
  skillDeletedSuccess: { en: "Skill deleted successfully", fi: "Osaaminen poistettu onnistuneesti" },
  confirmDeleteSkill: { en: "Are you sure you want to delete this skill?", fi: "Haluatko varmasti poistaa tämän osaamisen?" },
  noResults: { en: "No results found", fi: "Ei tuloksia" },

  "levels.beginner": { en: "Basic level", fi: "Perustaso" },
  "levels.intermediate": { en: "Proficient level", fi: "Edistynyt taso" },
  "levels.advanced": { en: "Expert level", fi: "Asiantuntijataso" },
  
  "tooltip.beginner": { en: "The person understands the basics and can work with the subject/technology.", fi: "Henkilö tuntee perusasiat ja pystyy työskentelemään aiheen/teknologian parissa." },
  "tooltip.intermediate": { en: "The person can work independently, has a versatile command of the technology, and can solve problems autonomously.", fi: "Henkilö kykenee itsenäiseen työskentelyyn, hallitsee teknologian monipuolisesti ja ratkaisee ongelmia itsenäisesti." },
  "tooltip.advanced": { en: "The person has a deep understanding of the technology or area of expertise, can train or help others, and solve even the most challenging problems.", fi: "Henkilöllä on syvällinen ymmärrys teknologiasta tai osaamisalueesta, hän kykenee kouluttamaan tai auttamaan muita ja ratkomaan haastavimmatkin ongelmat." },
};